export enum NotificationType {
  Confirmation = 0,
  Alert = 1,
  Error = 2,
}
